import { AligningType } from '../enums/aligning-type.enum';
import { CoachingType } from '../models/coaching-type.model';

export const CoachingTypeRepCard = {
    [CoachingType.NON_OA]: AligningType.NON_ALIGNED,
    [CoachingType.COACHED]: AligningType.ALIGNED,
};
